module.exports = __webpack_public_path__ + "static/media/glass-citrus.d0e49db8.svg";